<template>
    <h2 class="text-h2 pb-2 mb-4 border-b-2 border-line-strong">{{ title }}</h2>
</template>

<script lang="ts" setup>
defineProps<{
    title: string,
}>()
</script>
